import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { SearchAndFilterPackageSummary, SetSelectedFilters, SetSearchText } from '../store/actions/package-visualizer.actions';
import { Observable } from 'rxjs';
import { getSearchText, getIsLoading } from '../store/selectors/package-visualizer.selectors';
import { IAppState } from 'app/IAppState';

@Component({
  selector: 'biz-package-search-container',
  templateUrl: './package-search-container.component.html',
  styleUrls: ['./package-search-container.component.scss']
})
export class PackageSearchContainerComponent {
  public isLoadingList$: Observable<boolean>;
  public searchText$: Observable<string>;
  @Input()
  public set catalogObjects(value : Array<{type: string, objectList: ICatalogObject[]}>) {
    this._catalogObjects = _.cloneDeep(value);
  }
  public get catalogObjects(): Array<{type: string, objectList: ICatalogObject[]}> {
    return this._catalogObjects;
  }

  @Output() onFilterOptionsChange = new EventEmitter<Array<string>>();

  private _catalogObjects: Array<{type: string, objectList: ICatalogObject[]}>;

  constructor(private _store: Store<IAppState>) {
    this.searchText$ = this._store.pipe(select(getSearchText));
    this.isLoadingList$ = this._store.pipe(select(getIsLoading));
  }

  ngOnInit(): void {
    this._catalogObjects = [];
  }

  public filterPackageSummary(selectedFilters: Array<string>) {
    this._store.dispatch(new SetSelectedFilters(selectedFilters));
    this._store.dispatch(new SearchAndFilterPackageSummary());
  }

  ngOnDestroy() {
    this._store.dispatch(new SetSearchText(''));
  }
}
